// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3054b63c","289":"3c1323a2","360":"34534e31","405":"fabc321f","407":"023aaa40","514":"8fcab2f0","645":"bea6a3f9","787":"61a93da4"}[chunkId] + ".chunk.js";
};